module.exports = __webpack_public_path__ + "img/home-03.11238025.png";